
import { motion } from "framer-motion";
import { useState } from "react";
import { ArrowUpDown } from "lucide-react";
import StrategySorting from "./components/StrategySorting";
import ComparisonTable from "./components/ComparisonTable";
import { Button } from "@/components/ui/button";

interface MarketplaceHeaderProps {
  activeFiltersCount: number;
  sortBy: string;
  onSortChange: (value: string) => void;
}

const MarketplaceHeader = ({
  activeFiltersCount,
  sortBy,
  onSortChange
}: MarketplaceHeaderProps) => {
  const [showComparison, setShowComparison] = useState(false);

  return (
    <div className="mb-8">
      <h1 className="text-3xl md:text-4xl font-bold text-[#4A607B] text-center mb-2 sm:mb-4 my-[21px]">
        Boost Your Crypto Trading with Top Strategies.
      </h1>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="text-center"
      >
        <p className="text-gray-700 max-w-2xl mx-auto px-4 text-lg mb-4">
          Discover <span className="font-semibold">verified, human-curated copy trading strategies</span> that simplify crypto investing for everyone—from first-timers to seasoned pros.
        </p>

        <Button 
          variant="ghost" 
          size="sm"
          onClick={() => setShowComparison(true)}
          className="text-gray-500 hover:text-gray-700"
        >
          <ArrowUpDown className="w-4 h-4 mr-2" />
          Compare Free vs. Premium Strategies
        </Button>
      </motion.div>

      <ComparisonTable 
        isOpen={showComparison} 
        onClose={() => setShowComparison(false)} 
      />
    </div>
  );
};

export default MarketplaceHeader;
